import styled from 'styled-components';
import { SectionParagraph, SectionTitle as Title, Section } from '@/components/shared/Content';
import type { GetCoveredProps } from '../renters/GetCovered';

const Subtitle = styled(SectionParagraph)`
  margin-top: 20px;
`;
const Container = styled(Section)`
  flex-direction: column;
  text-align: center;
  position: relative;
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin-top: 30px;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  padding-bottom: 56.25%;
`;

const VideoIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
export const Video = ({ title, subtitle }: Pick<GetCoveredProps, 'title' | 'subtitle'>) => {
  return (
    <Container py={[60, 96]} px={20} darkBackground id="video">
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <VideoWrapper>
        <VideoContainer>
          <VideoIframe
            src="https://www.youtube.com/embed/OwYsF7iLlPw"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </VideoContainer>
      </VideoWrapper>
    </Container>
  );
};
